/* eslint-disable react-hooks/rules-of-hooks */
import {
  Box,
  Flex,
  Text,
  IconButton,
  Button,
  Stack,
  VStack,
  Collapse,
  Icon,
  Link,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
  useDisclosure,
  Container,
  useColorMode,
  Menu,
  MenuButton,
  HStack,
  MenuList,
  MenuItem,
  MenuDivider,
  useToast,
  Skeleton,
} from '@chakra-ui/react';
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  MoonIcon,
  SunIcon,
} from '@chakra-ui/icons';
import { useAccount } from '../context/AccountProvider';
import { userLogin } from '../common/api';
import { useEffect, useState } from 'react';
import { Tooltip } from '@chakra-ui/react';
import smartTruncate from 'smart-truncate';
import { FiChevronDown } from 'react-icons/fi';
import { useSelector } from 'react-redux';

export default function AppNavigation() {
  const toast = useToast();
  const { isOpen, onToggle } = useDisclosure();
  const { colorMode, toggleColorMode } = useColorMode();
  const { accountAddress, noWalletDetect } = useSelector((state) => state.account);
  
  // isLoggedIn should be true when we have an account address (wallet connected)
  const isLoggedIn = Boolean(accountAddress && !noWalletDetect);

  const loginHandler = () => {
    if (!window.tronWeb || !window.tronWeb.ready) {
      return toast({
        title: 'Wallet not connected.',
        description: 'Please install and connect TronLink wallet.',
        status: 'warning',
        duration: 6000,
        isClosable: true,
      });
    }

    const walletAddress = window.tronWeb.defaultAddress.base58;
    userLogin(walletAddress)
      .then((res) => {
        localStorage.setItem('token', res);
        toast({
          title: 'Wallet connected successfully!',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      })
      .catch((err) => {
        console.error('Login failed:', err);
        toast({
          title: 'Login failed.',
          description: 'Unable to sign transaction.',
          status: 'error',
          duration: 6000,
          isClosable: true,
        });
      });
  };

  const disconnectWallet = () => {
    localStorage.removeItem('token');
    toast({
      title: 'Wallet disconnected',
      status: 'info',
      duration: 2000,
      isClosable: true,
    });
  };

  // Clean up token when wallet is disconnected
  useEffect(() => {
    if (noWalletDetect) {
      localStorage.removeItem('token');
    }
  }, [noWalletDetect]);

  return (
    <Box>
      <Flex
        bg={useColorModeValue('white', 'gray.800')}
        color={useColorModeValue('gray.600', 'white')}
        minH={'60px'}
        borderBottom={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.200', 'gray.900')}
        align={'center'}
        margin={{ base: '20px 10px 0px 10px', md: '25px 32px 15px' }}
        boxShadow={'0 10px 20px rgba(0,0,0,.05)'}
        borderRadius={'10px'}
      >
        <Container maxW='100%' display='flex' align='center' px={{ base: 2, sm: 3, md: 5 }}>
          <Flex
            flex={{ base: 'none', md: 'auto' }}
            ml={{ base: 0, md: -2 }}
            display={{ base: 'flex', md: 'none' }}
            align='center'
          >
            <IconButton
              onClick={onToggle}
              icon={
                isOpen ? (
                  <CloseIcon w={3} h={3} />
                ) : (
                  <HamburgerIcon w={5} h={5} />
                )
              }
              variant={'ghost'}
              aria-label={'Toggle Navigation'}
              size="md"
            />
          </Flex>
          <Flex
            flex={{ base: 1, md: '100%' }}
            justify={{ base: 'center', md: 'space-between' }}
            align='center'
          >
            <Box display={{ base: 'none', sm: 'block' }}>
              <Link href='/'>
              {colorMode === 'light' ? (
                <img
                  src={require('../assets/img/logo/logo_dark.png')}
                  alt='Logo'
                  width={'180px'}
                />
              ) : (
                <img
                  src={require('../assets/img/logo/logo_light.png')}
                  alt='Logo'
                  width={'180px'}
                />
              )}
              </Link>
            </Box>
            <Flex display={{ base: 'none', md: 'flex' }} ml={10}>
              <DesktopNav />
            </Flex>
            <Stack
              flex={{ base: 1, md: 0 }}
              justify={'flex-end'}
              direction={'row'}
              spacing={6}
              align='center'
            >
              <IconButton
                aria-label='Search'
                onClick={toggleColorMode}
                icon={colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
                backgroundColor='transparent'
              />
              {!accountAddress && (
                <Button className='primary' onClick={loginHandler}>
                  <p>
                    Connect<span className='below-tab'> Wallet</span>
                  </p>
                </Button>
              )}

              {accountAddress && (
                <Menu>
                  <MenuButton
                    py={2}
                    transition='all 0.3s'
                    _focus={{ boxShadow: 'none' }}
                  >
                    <HStack>
                      <Button
                        className='logged-in-btn'
                        onClick={disconnectWallet}
                      >
                        <img
                          src={require('../assets/img/tron.png')}
                          alt='tron'
                        />{' '}
                        <span>
                          {smartTruncate(accountAddress, 18, { position: 8 })}
                        </span>
                      </Button>

                      <Box display={{ base: 'none', md: 'flex' }}>
                        <FiChevronDown />
                      </Box>
                    </HStack>
                  </MenuButton>
                  <MenuList
                    bg={useColorModeValue('white', 'gray.900')}
                    borderColor={useColorModeValue('gray.200', 'gray.700')}
                  >
                    <MenuItem
                      onClick={() => window.location.replace('/dashboard')}
                    >
                      Dashboard
                    </MenuItem>
                    <MenuDivider />
                    <MenuItem onClick={disconnectWallet}>Sign out</MenuItem>
                  </MenuList>
                </Menu>
              )}
            </Stack>
          </Flex>
        </Container>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <MobileNav />
      </Collapse>
    </Box>
  );
}

const DesktopNav = () => {
  const linkColor = useColorModeValue('gray.600', 'gray.200');
  const linkHoverColor = useColorModeValue('gray.800', 'white');
  const popoverContentBgColor = useColorModeValue('white', 'gray.800');

  return (
    <Stack direction={'row'} spacing={4}>
      {NAV_ITEMS.map((navItem) => (
        <Box key={navItem.label}>
          <Popover trigger={'hover'} placement={'bottom-start'}>
            <PopoverTrigger>
              <Tooltip
                label={navItem.label == 'APIs' ? 'Comming Soon' : null}
                placement='auto-start'
              >
                <Link
                  p={2}
                  href={navItem.href ?? '#'}
                  fontSize={'sm'}
                  fontWeight={500}
                  color={linkColor}
                  disabled={true}
                  _hover={{
                    textDecoration: 'none',
                    color: linkHoverColor,
                  }}
                >
                  {navItem.label}
                </Link>
              </Tooltip>
            </PopoverTrigger>

            {navItem.children && (
              <PopoverContent
                border={0}
                boxShadow={'xl'}
                bg={popoverContentBgColor}
                p={4}
                rounded={'xl'}
                minW={'sm'}
              >
                <Stack>
                  {navItem.children.map((child) => (
                    <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
    </Stack>
  );
};

const DesktopSubNav = ({ label, href, subLabel }) => {
  return (
    <Link
      href={href}
      role={'group'}
      display={'block'}
      p={2}
      rounded={'md'}
      _hover={{ bg: useColorModeValue('pink.50', 'gray.900') }}
    >
      <Stack direction={'row'} align={'center'}>
        <Box>
          <Text
            transition={'all .3s ease'}
            _groupHover={{ color: 'pink.400' }}
            fontWeight={500}
          >
            {label}
          </Text>
          <Text fontSize={'sm'}>{subLabel}</Text>
        </Box>
        <Flex
          transition={'all .3s ease'}
          transform={'translateX(-10px)'}
          opacity={0}
          _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
          justify={'flex-end'}
          align={'center'}
          flex={1}
        >
          <Icon color={'pink.400'} w={5} h={5} as={ChevronRightIcon} />
        </Flex>
      </Stack>
    </Link>
  );
};

const MobileNav = () => {
  return (
    <Box
      bg={useColorModeValue('white', 'gray.800')}
      display={{ md: 'none' }}
      boxShadow={useColorModeValue('0 4px 6px rgba(0,0,0,0.1)', '0 4px 6px rgba(0,0,0,0.3)')}
      borderRadius={{ base: '0 0 12px 12px', md: '0' }}
      mx={{ base: '10px', md: 0 }}
      overflow="hidden"
    >
      <VStack spacing={0} align="stretch">
        {NAV_ITEMS.map((navItem, index) => (
          <MobileNavItem key={navItem.label} {...navItem} isLast={index === NAV_ITEMS.length - 1} />
        ))}
      </VStack>
    </Box>
  );
};

const MobileNavItem = ({ label, children, href, isLast }) => {
  const { isOpen, onToggle } = useDisclosure();
  const hoverBg = useColorModeValue('gray.50', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const borderColor = useColorModeValue('gray.100', 'gray.600');

  return (
    <Box borderBottom={!isLast ? '1px solid' : 'none'} borderColor={borderColor}>
      <Flex
        as={href ? Link : Box}
        href={href !== '#' ? href : undefined}
        py={4}
        px={6}
        justify={'space-between'}
        align={'center'}
        cursor="pointer"
        _hover={{
          bg: hoverBg,
          textDecoration: 'none',
        }}
        onClick={children ? onToggle : href === '#' ? (e) => e.preventDefault() : undefined}
      >
        <Text
          fontSize="lg"
          fontWeight={500}
          color={textColor}
        >
          {label}
        </Text>
        {children && (
          <Icon
            as={ChevronDownIcon}
            transition={'all .25s ease-in-out'}
            transform={isOpen ? 'rotate(180deg)' : ''}
            w={5}
            h={5}
            color={useColorModeValue('gray.400', 'gray.500')}
          />
        )}
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <VStack
          align={'stretch'}
          spacing={0}
          bg={useColorModeValue('gray.25', 'gray.750')}
        >
          {children &&
            children.map((child, index) => (
              <Link 
                key={child.label} 
                href={child.href}
                py={3}
                px={8}
                fontSize="md"
                color={useColorModeValue('gray.600', 'gray.300')}
                _hover={{
                  bg: useColorModeValue('gray.100', 'gray.600'),
                  textDecoration: 'none'
                }}
                borderBottom={index < children.length - 1 ? '1px solid' : 'none'}
                borderColor={borderColor}
              >
                {child.label}
              </Link>
            ))}
        </VStack>
      </Collapse>
    </Box>
  );
};

const NAV_ITEMS = [
  {
    label: 'Stake & Earn',
    href: '/stake',
  },
  // {
  //   label: "Advertise",
  //   href: "#",
  // },
  {
    label: 'APIs',
    href: '#',
  },
];
